import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { NoResultFoundComponent } from 'app/modules/shared/components/no-result-found/no-result-found.component';
import { StatusComponent } from 'app/modules/shared/components/status/status.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { Country } from 'app/modules/shared/models/country';
import { Status } from 'app/modules/shared/models/status';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { OverviewDetailsComponent } from './overview-details/overview-details/overview-details.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChangeReviewStatusComponent } from '../change-review-status/change-review-status.component';

@Component({
  selector: 'app-change-review-details',
  standalone: true,
  imports: [
    BreadcrumbModule,
    StatusComponent,
    TabViewModule,
    TranslateModule,
    MenuModule,
    ToastModule,
    OverviewDetailsComponent,
    ButtonModule,
    AccessProviderDirective,
    NoResultFoundComponent,
    DropdownModule,
    FormsModule,
    ChangeReviewStatusComponent
  ],
  templateUrl: './change-review-details.component.html',
  styleUrl: './change-review-details.component.scss'
})
export class ChangeReviewDetailsComponent implements OnInit {

  @Input() tableData: any[];
  routePath: MenuItem[] = [];
  productId: string;
  dataForVehicleStatus: Array<Status> = [];
  userId: any = '';
  country: Country;
  activeIndex: any = 0;
  data: any;
  protocolAttributeData: any;
  attributeLabels = {};
  productAttributeLength;
  attributeValues: any;
  showStatus: boolean = false;
  protocolReviewRequestId;
  currentRow;
  changeReviewDetails: any;
  changeReviewRowData: any
  entityForStatus: any;
  editBtnLabel: any;
  relatedData: any;
  driverList: any[] = [];
  statusDetails;
  selectedStatus: string = '';
  updatedStatus;
  updatedComment;
  currentReviewData;
  entityCode;
  protocolRefID;

  constructor(private route: ActivatedRoute,
    public cs: CommonBindingDataService,
    private cd: ChangeDetectorRef,
    private trialReviewService: EntityService,
    private storageService: StorageService,
    private router: Router) {

  }

  ngOnInit() {
    this.protocolReviewRequestId = this.route.snapshot.paramMap.get('id');
    this.getProductDetails();
    this.editBtnLabel = this.cs.getLabel('change_review.lbl_view_change');
    this.routePath = [
      {
        label: this.cs.getLabel('change_review.lbl_change_reviews'),
        routerLink: '/app/change-review',
        icon: 'pi pi-arrow-left',
        iconStyle: { 'font-weight': 'bold', 'margin-right': '10px' },
        command: () => {
          this.storageService.setItem('vehicleActiveIndex', 0);
          this.router.navigate['app/change-review'];
        }
      },
      {
        label: this.cs.getLabel('change_review.lbl_details'),
        routerLink: `../${  this.protocolReviewRequestId}`,
        styleClass: 'breadcrumb-child forward-slash breadcrumb-text',
        style: { 'display': 'flex', 'top': '2px', 'position': 'relative' }
      },
    ];
    this.trialReviewService.entityCurrentRow.subscribe(res => {
      this.currentRow = res;
    });

  }

  getProductDetails() {
    this.trialReviewService.getEntityForChangeReview(this.protocolReviewRequestId, AppSettings.ENTITY_CODE.CHANGE_REVIEW).subscribe((result: any) => {
      this.attributeValues = result;
      this.protocolRefID = result.protocolId;
      this.entityCode  = result.model.trim().toLowerCase().replace(/\s+/g, '_');
    });
  }

  redirectToEdit() {
    let tab: string;

      if (this.entityCode === 'protocol_product') {
        tab = 'products';
      } else if (this.entityCode === 'protocol_purchase_order') {
        tab = 'purchase-orders';
      } else if (this.entityCode === 'protocol_sponsor') {
        tab = 'sponsors';
      } else if (this.entityCode === 'protocol_user') {
        tab = 'protocol-users';
      } else if (this.entityCode === 'protocol_patient') {
        tab = 'patients';
      } else if (this.entityCode === 'protocol_site') {
        tab = 'sites';
      } else if (this.entityCode === 'order') {
        tab = 'orders';
      } else {
         tab = 'overview';
      }

    this.router.navigate(['app/trials/trial-details'], {
      queryParams: {
        tab,
        id: this.attributeValues.protocolId
      }
    });

  }

}
